module.exports = __webpack_public_path__ + "static/schlederer-res-86c9ae67a9286a8c2b0da884d3065a26.jpg";